<div class="info-container">
  <div class="info-container__header" id="header-info">
    <p class="info-container__header__title">{{ 'NGX-MESSAGING.conversationInfo' | translate }}</p>
    <div class="info-container__header__close-btn">
      <mat-icon (click)="toggleSidebar(false)" svgIcon="close_circle"></mat-icon>
    </div>
  </div>
  <div class="info-container__content">
    <div id="first-content" class="info-container__first-content">
      <div class="info-container__content__image">
        <messaging-avatar
          size="100"
          [name]="selectedChannel()?.displayName || 'N A'"
          [initialsSize]="2"
          [src]="$safeNavigationMigration(selectedChannel()?.imageURL)"
          [ngStyle]="{ cursor: selectedChannel()?.imageURL ? 'pointer' : 'default' }"
          (click)="imagesService.openPhoto(selectedChannel()?.imageURL ?? '', undefined, false)">
        </messaging-avatar>
      </div>
      <div class="info-container__content__title">
        {{ selectedChannel()?.displayName }}
        @if (selectedChannel()?.displayName === 'Orphan message') {
        <mat-icon
          *hasWorkspaceFeature="[WorkspaceFeatures.canEditDisplayNameChannel]"
          [svgIcon]="'pencil'"
          (click)="editChannel()"></mat-icon>
        }
      </div>
      @if(selectedChannel()?.isMember) {
      <div
        *hasWorkspaceFeature="[WorkspaceFeatures.canUseOptInToggle]"
        class="info-container__content__actions"
        (click)="optInOutState()">
        <span class="info-container__content__actions__label">
          {{ optStatus() ? ('NGX-MESSAGING.optedIn' | translate) : ('NGX-MESSAGING.optedOut' | translate) }}
        </span>
        <span
          class="info-container__content__actions__dot"
          [class.info-container__content__actions__dot--on]="optStatus()"></span>
      </div>
      <div
        *hasWorkspaceFeature="[WorkspaceFeatures.canPinChannels]"
        class="info-container__content__actions"
        (click)="pinChat()">
        <mat-icon [svgIcon]="selectedChannel()?.pinned ? 'bookmark_off' : 'bookmark'"></mat-icon>
        <span class="info-container__content__actions__label">
          {{ selectedChannel()?.pinned ? ('Unpin channel' | translate) : ('Pin channel' | translate) }}
        </span>
      </div>
      <div
        *hasWorkspaceFeature="[WorkspaceFeatures.canMuteChannels]"
        class="info-container__content__actions"
        (click)="muteChannel()">
        <mat-icon [svgIcon]="isMuted() ? 'volume' : 'volume_off'"></mat-icon>
        <span class="info-container__content__actions__label">
          {{ isMuted() ? ('NGX-MESSAGING.unmuteChannel' | translate) : ('NGX-MESSAGING.muteChannel' | translate) }}
        </span>
      </div>
      <div
        class="info-container__content__actions"
        (click)="setAsRead(selectedChannel()!, !(selectedChannel()?.unread || selectedChannel()?.unreadMessages))">
        <span
          class="info-container__content__actions__status"
          [class.info-container__content__actions__status--unread]="
            selectedChannel()?.unread || (selectedChannel()?.unreadMessages ?? 0) > 0
          "></span>
        <span class="info-container__content__actions__label">
          {{
            !(selectedChannel()?.unread || selectedChannel()?.unreadMessages)
              ? ('NGX-MESSAGING.mark_as_unread' | translate)
              : ('NGX-MESSAGING.mark_as_read' | translate)
          }}
        </span>
        @if ((selectedChannel()?.unreadMessages ?? 0) > 0) {
        <span class="info-container__content__actions__unreads">
          {{ selectedChannel()!.unreadMessages }}
        </span>
        }
      </div>
      }
      <ng-container *hasWorkspaceFeature="[WorkspaceFeatures.canChangeConversationStatus]">
        <ngx-manual-status></ngx-manual-status>
      </ng-container>
      @if (orderId() && showGoToOrderButton()){
      <button class="order-button" mat-raised-button (click)="emitOrder()" color="primary">
        {{ 'NGX-MESSAGING.go_to' | translate }} {{ selectedWorkSpace()?.productType }}
      </button>
      }
    </div>
    <div class="info-container__members" [style.height]="calculateContainerMembersHeight()">
      @if ( selectedChannel()?.type === ChannelType.GROUP || selectedChannel()?.type === ChannelType.SUPPORT ||
      (selectedChannel()?.type === ChannelType.BROADCAST && selectedChannel()?.member?.role === ChannelRoles.ADMIN)) {
      <ngx-members
        [canDelete]="true"
        [canAddMembers]="true"
        [showRoles]="true"
        [listHeight]="sizeListMembers()"></ngx-members>
      }
    </div>
  </div>

  @if (selectedChannel()?.isMember && selectedChannel()?.type === ChannelType.GROUP) {
  <div id="footer-info" class="info-container__content__actions footer" (click)="leaveChannel()">
    <mat-icon [svgIcon]="'logout'"></mat-icon>
    {{ 'NGX-MESSAGING.leaveChannel' | translate }}
  </div>
  }
</div>
